import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

//import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

// this is like a ViewModel, contains all user actions for this component
export class DocumentBuilderViewStore extends BaseViewStore {

  hasRandomized = false;

  // validation is a derivation
  @computed get invalid() {
    /*const invalid = {};
    const {
      contentModel: {
        userInput: {
          value: userInputValue
        }
      }
    } = this.props;

    if(!userInputValue) invalid.userInput = "User, please provide a value!"

    return invalid;*/
    return false;
  }  

  // actions update state
  @action.bound updateUserInput(val) {
    /*const {
      contentModel
    } = this.props;

    // this updates user input property `userInput`, defined on the contentModel
    contentModel.updateInput("userInput", val)*/
  }

  @action.bound save() {
    const contentModel = this.props.contentModel;
    this.props.contentModel.isSubmitted = true;

    const set = {};
    contentModel.items.forEach((item) => {
      set[contentModel.id + "_" + item.id] = item.inTarget ? item.targetIndex : -1;
    });

    set[contentModel.id + "_isCompleted"] = true;
    set[contentModel.id + "_isSubmitted"] = true;
    window.simgate.updateData({
        path: window.application.dataModel.domainStore.context.team.pathId,
        set: set
    }).then(action("loadData-callback", res => {
    })).catch(action("loadData-error", err => {
        debugger;
        alert("There was a problem saving your data - " + err);
    }));
  }
  
}

//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
@autoclass // this automatically gives consistent `className`s to components using module and component names
export class DocumentBuilder extends BaseComponent {

  static ViewStore = DocumentBuilderViewStore; //ViewStore gets auto-instantiated and attached to the component on creation

  sourceItems() {
    if (!this.props.contentModel) return []
    let items = this.props.contentModel.items.filter(item => !item.inTarget)
    return items.sort((a, b) => {
      if (a.sourceIndex < b.sourceIndex) {
        return -1;
      }
      if (a.sourceIndex > b.sourceIndex) {
        return 1;
      }
      return 0;
    })
  }

  targetItems() {
    if (!this.props.contentModel) return []
    let items = this.props.contentModel.items.filter(item => item.inTarget)
    return items.sort((a, b) => {
      if (a.targetIndex < b.targetIndex) {
        return -1;
      }
      if (a.targetIndex > b.targetIndex) {
        return 1;
      }
      return 0;
    })
  }

  @action.bound
  moveItemFromSourceToTarget(item) {
    let array = this.sourceItems().slice()

    for (var i = item.sourceIndex; i < array.length; i++) {
      array[i].sourceIndex -= 1;
    }

    item.targetIndex = this.targetItems().length;
    item.inTarget = true;
    item.sourceIndex = -1;
  }

  @action.bound
  moveItemFromTargetToSource(item) {
    let array = this.targetItems().slice()

    for (var i = item.targetIndex; i < array.length; i++) {
      array[i].targetIndex -= 1;
    }

    item.sourceIndex = this.sourceItems().length;
    item.inTarget = false
    item.targetIndex = -1;
  }

  @action.bound
  move(from, to) {
    let array = this.targetItems().slice()
    if (to === from) return;

    var target = array[from];
    var increment = to < from ? -1 : 1;

    for (var k = from; k != to; k += increment) {
      array[k] = array[k + increment];
    }
    array[to] = target;
    let i = 0
    for (let item of array) item.targetIndex = i++
  }


  @action.bound
  moveTargetItemDown(item) {
    if (item.targetIndex < this.targetItems().length - 1) {
      this.move(item.targetIndex, item.targetIndex + 1)
    }
  }

  @action.bound
  moveTargetItemUp(item) {
    let index = item.targetIndex
    if (item.targetIndex > 0) {
      this.move(item.targetIndex, item.targetIndex - 1)
    }
  }

  canMoveDown(item) {
    let arr = item.inTarget ? this.targetItems() : this.sourceItems();
    let index = item.inTarget ? item.targetIndex : item.sourceIndex;
    return index < (arr.length - 1);
  }

  canMoveUp(item) {
    let index = item.inTarget ? item.targetIndex : item.sourceIndex;
    return index > 0;
  }


  componentWillMount() {
    const {
      currentView, // the parent view container, may have options etc attached depending on context
      contentModel // the hydrated contentModel
    } = this.props;

    if(contentModel.randomizeItems && !this.viewStore.hasRandomized) {
      this.viewStore.hasRandomized = true;
      var list = [];
      for(var i = 0; i < contentModel.items.length; ++i) {
        list.push(i);
      }
      list = list.sort(function(a, b) {
        return Math.random() - 0.5;
      });
      for(var i = 0; i < contentModel.items.length; ++i) {
        contentModel.items[i].sourceIndex = list[i];
        contentModel.items[i].targetIndex = -1;
        contentModel.items[i].inTarget = false;
      }
    }
    else {
      for(var i = 0; i < contentModel.items.length; ++i) {
        contentModel.items[i].sourceIndex = i;
        contentModel.items[i].targetIndex = -1;
        contentModel.items[i].inTarget = false;
      }
    }
  }

  render() {

    const {
      currentView, // the parent view container, may have options etc attached depending on context
      contentModel // the hydrated contentModel
    } = this.props;

    const {
      items,
      activityTitle,
      preActivityText,
      sourceTitle,
      targetTitle,
      postActivityText
      //userInput: {value: userInputValue}
    } = contentModel; // this contentModel's properties

    const {
      updateUserInput,
      invalid,
      save,
    } = this.viewStore; // this components viewStore.  Will have actions and UI properties

    var self = this;

    var available = [];
    var selected = [];
    for(var i = 0; i < this.sourceItems().length; ++i) {
      (function(item) {
        available.push(
          <div className="styled-item" key={i} onClick={(id) => self.moveItemFromSourceToTarget(item)}>
            <div className="item-content" dangerouslySetInnerHTML={{ __html: item.content }}></div>
            <div className="source-to-target">
              <div className="fa fa-caret-right"></div>
            </div>
          </div>
        );
      })(this.sourceItems()[i]);
    }
    for(var i = 0; i < this.targetItems().length; ++i) {
      (function(item) {
        selected.push(
          <div className="styled-item back" key={i}>
            <div className="target-to-source-wrapper" onClick={(id) => self.moveItemFromTargetToSource(item)}>
              <div className="target-to-source">
                <div className="fa fa-caret-left"></div>
              </div>
              <div className="item-content" dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </div>
            <div className="target-prioritizer">
              {(item.targetIndex > 0) ? <div className="move-up" onClick={(id) => self.moveTargetItemUp(item)}>
                <div className="fa fa-caret-up"></div>
              </div> : ''}
              {(item.targetIndex < (self.targetItems().length - 1)) ? <div className="move-down" onClick={(id) => self.moveTargetItemDown(item)}>
                <div className="fa fa-caret-down"></div>
              </div> : ''}
            </div>
          </div>
        );
      })(this.targetItems()[i]);
    }

    let disabled = false;
    if(available.length == 0) {
      available.push(<div className="no-items"><span>List Empty</span></div>);
    }
    if(selected.length == 0) {
      disabled = true;
      selected.push(<div className="no-items"><span>List Empty</span></div>);
    }

    return (
      <div className="list-builder-wrapper form">
        {activityTitle && <div className="activity-title">{activityTitle}</div>}
        {preActivityText && <div className="instructions text-sm" dangerouslySetInnerHTML={{__html:preActivityText}}></div>}
        <div className="list-builder">
          <div className="source-set">
            <div className="title">{sourceTitle}</div>
            <div className="list scrollbar">
              {available}
            </div>
          </div>
          <div className="target-set">
            <div className="title">{targetTitle}</div>
            <div className="list scrollbar">
              {selected}
            </div>
          </div>
        </div>
        {postActivityText && <div className="instructions" dangerouslySetInnerHTML={{__html:postActivityText}}></div>}
        <div className={"btn btn-main-small right" + (disabled ? " disabled" : "")} onClick={save}>Submit</div>
      </div>
      );
  }


}
export default DocumentBuilder; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/document-builder-activity/src/component.js